function LayoutMain({children}) {
    return (
        <>
            {children}
        </>
    );

}

export default LayoutMain;